'use client';

import { IconButton } from '@svenskaspelab/ui/react/button';
import MenuLeft from '@svenskaspelab/ui/react/icons/MenuLeft';
import MenuRight from '@svenskaspelab/ui/react/icons/MenuRight';
import type { ReactNode } from 'react';

type CarouselNavigationIndicatorProps = {
  count: number;
  selectedIndex: number;
  onDotClick: (index: number) => void;
  onPrevious: () => void;
  onNext: () => void;
  canScrollPrev: boolean;
  canScrollNext: boolean;
};

export default function CarouselNavigationIndicator({
  count,
  selectedIndex,
  onDotClick,
  onPrevious,
  onNext,
  canScrollPrev,
  canScrollNext,
}: CarouselNavigationIndicatorProps): ReactNode {
  return (
    <div className="flex items-center justify-center gap-2">
      <IconButton label="Föregående" variant="ghost" disabled={!canScrollPrev} onClick={onPrevious}>
        <MenuLeft />
      </IconButton>

      <div className="flex items-center gap-1">
        {Array.from({ length: count }, (_, i) => (
          <IconButton
            key={i}
            label={`Sida ${i + 1} av ${count}`}
            aria-current={i === selectedIndex ? 'page' : undefined}
            variant="ghost"
            size="sm"
            onClick={() => onDotClick(i)}
            className="p-0"
          >
            <span
              className={`border-primary h-4 w-4 rounded-full border-2 ${i === selectedIndex ? 'bg-primary' : ''}`}
            />
          </IconButton>
        ))}
      </div>

      <IconButton label="Nästa" variant="ghost" disabled={!canScrollNext} onClick={onNext}>
        <MenuRight />
      </IconButton>
    </div>
  );
}
